import { Component, Inject, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AppComponent } from "../app/app.component";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
    selector: "involvedped",
    template: require('./involvedped.component.html'),
    styles: [require('./involvedped.component.css')]
})
export class InvolvedPedComponent implements OnChanges {

    report: CollisionReport;
    involvedPassergerInfo: InvolvedPassergerInfo;

    constructor(private appcomponent: AppComponent, private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private router: Router, private spinnerService: Ng4LoadingSpinnerService) {
        this.report = appcomponent.getReport();
        if (this.report.CollisionReportUniqueId == null) {
            this.reportGetSync();
            this.router.navigate([this.router.url])
        }
        if (this.report.IsNew) {
            this.router.navigate(["home"]);
        }
        if (this.report.InvolvedPassergerInfos == null || this.report.InvolvedPassergerInfos.length == 0)
            this.report.InvolvedPassergerInfos = [];
        this.involvedPassergerInfo = <InvolvedPassergerInfo>{};
        document.body.scrollTop = 0;
    }

    onPhoneInput(): void {
        var v = this.involvedPassergerInfo.InvPsgPhone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        this.involvedPassergerInfo.InvPsgPhone = v;
    }

    onPhoneInputMed(): void {
        var v = this.involvedPassergerInfo.InvPsgMedicalProfessionalPhone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        this.involvedPassergerInfo.InvPsgMedicalProfessionalPhone = v;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (typeof changes['report'] !== "undefined") {
            // retrieve the report variable change info
            var change = changes['report'];
            // only perform the task if the value has been changed
            if (!change.isFirstChange()) {
                // execute the Http request and retrieve the result
                //DO SOmething
            }
        }
        else
            console.log("Undefined");
    }
    onBack(): void {
        this.BackAndPost("involved");
    }
    private BackAndPost(page: string): void {

        this.report.CurrentPage = page;
    //    this.appcomponent.setReport(this.report);
        this.router.navigate([page]);
    }
    onSubmit(): void {
        //   alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.report));
        //this.ValidateAndPost("environment");
        this.ValidateAndPost("vehicledriverlocation");
        //vehicledriverlocation
        //GO TO NEXT PAGE
    }

    private ValidateAndPost(page: string) {
        this.report.IsInvolvedPageValid = true;
        this.report.CurrentPage = page;
        this.appcomponent.setReport(this.report);
        this.router.navigate([page]);
    }

    onInvolvedHavePassengerTypeChange(PassergerType: string): void {
        this.report.InvolvedHavePassenger = PassergerType;
        this.involvedPassergerInfo.InvPsgPositionInVehicle = PassergerType;
    }


    onInvPsgPersonInjuredInCrashTypeChange(crash: boolean): void {
        this.involvedPassergerInfo.InvPsgPersonInjuredInCrash = crash;
    }

    onInvPsgPersonReportToInsuranceChange(inv_psg_report: boolean): void {
        this.involvedPassergerInfo.InvPsgPersonReportToInsurance = inv_psg_report;
    }

    onInvPsgConsultionMedicalProfessionalChange(inv_psg_cons_med_prof: boolean): void {
        this.involvedPassergerInfo.InvPsgConsultionMedicalProfessional = inv_psg_cons_med_prof;
    }
    onInvPsgPersonInjuryPastFiveYearChange(inv_psg_inj_five_years: boolean): void {
        this.involvedPassergerInfo.InvPsgPersonInjuredInCrash = inv_psg_inj_five_years;
    }

    onInvPsgPersonUseSeatbeltChange(inv_psg_use_seatbelt: boolean): void {
        this.involvedPassergerInfo.InvPsgPersonUseSeatbelt = inv_psg_use_seatbelt;
    }

    onInvPsgPersonOwnAVehicleChange(inv_psg_have_vehicle: boolean): void {
        this.involvedPassergerInfo.InvPsgPersonOwnAVehicle = inv_psg_have_vehicle;
    }

    onInvPsgPersonAttendTodayChange(isAttend: boolean): void {
        this.involvedPassergerInfo.InvPsgPersonAttendToday = isAttend;
    } 
    onInvPsgOwnACarChange(value: boolean): void {
        this.involvedPassergerInfo.InvPsgOwnACar = value;
    } 

    onAddPasserger(): void {
        this.report.InvolvedPassergerInfos.push(this.involvedPassergerInfo);
    }
    onAddInvolved(): void {
        if (this.Isvalid() && this.report.InvolvedHavePassenger != "NO") {
            this.involvedPassergerInfo.InvolvedPersonIndex = this.report.InvolvedPassergerInfos.length + 1;
            this.involvedPassergerInfo.CollisionReportId = this.report.CollisionReportId;
            var url = this.baseUrl + "api/report/UpdateInvolved";
            this.spinnerService.show();
            this.http
                .post(url, this.involvedPassergerInfo)
                .subscribe(res => {
                    var v = res as InvolvedPassergerInfo;
                    this.involvedPassergerInfo = v;
                    this.report.InvolvedPassergerInfos.push(this.involvedPassergerInfo);
                    this.involvedPassergerInfo = <InvolvedPassergerInfo>{};
                    window.scrollTo(0, 0);
                }, error => console.log(error), () => this.spinnerService.hide());

            this.onInvolvedHavePassengerTypeChange('NO');
        }
    }
    onSelectInvolved(involved: InvolvedPassergerInfo): void {
        this.involvedPassergerInfo = <InvolvedPassergerInfo>{};
        this.involvedPassergerInfo = involved;
    }
    onDeleteInvolved(involved: InvolvedPassergerInfo): void {
            if (confirm("Do you really want to delete this entity?")) {
                for (var i = 0; i < this.report.InvolvedPassergerInfos.length; i++) {
                    if (this.report.InvolvedPassergerInfos[i].InvolvedPersonIndex == involved.InvolvedPersonIndex) {

                        if (this.report.InvolvedPassergerInfos[i].InvolvedId > 0) {
                            var url = this.baseUrl + "api/report/DeleteInvolved/" + this.report.InvolvedPassergerInfos[i].InvolvedId ;
                            this.http
                                .delete(url)
                                .subscribe(res => {
                                    this.report.InvolvedPassergerInfos.splice(i, 1);
                                }, error => console.log(error));
                        }
                        else
                        this.report.InvolvedPassergerInfos.splice(i, 1);
                        break;
                    }
                }
            }
        
    }
    onEditInvolved(): void {
        if (this.Isvalid()) {
            for (var i = 0; i < this.report.InvolvedPassergerInfos.length; i++) {
                if (this.report.InvolvedPassergerInfos[i].InvolvedPersonIndex == this.involvedPassergerInfo.InvolvedPersonIndex) {
                    var url = this.baseUrl + "api/report/UpdateInvolved";
                    this.spinnerService.show();
                    this.http
                        .post(url, this.involvedPassergerInfo)
                        .subscribe(res => {
                            var v = res as InvolvedPassergerInfo;
                            this.involvedPassergerInfo = v;
                        }, error => console.log(error), () => this.spinnerService.hide());
                    this.report.InvolvedPassergerInfos[i] = this.involvedPassergerInfo;
                    this.involvedPassergerInfo = <InvolvedPassergerInfo>{};
                    break;
                }
            }
        }
    }
    onCancelInvolved(): void {
        this.involvedPassergerInfo = <InvolvedPassergerInfo>{};
    }
    private Isvalid(): boolean {
        
        if (this.involvedPassergerInfo.InvPsgLastName == null || this.involvedPassergerInfo.InvPsgLastName.trim().length == 0) {
            return false;
        }

        return true;
    }

    reportGetSync(): void {
        var url = this.baseUrl + "api/report";
        this.http
            .get(url)
            .toPromise().then(result => {
                var v = result as CollisionReport;
                this.report = v;
            });
    }

}